module.exports = {"230621100":"肇州镇","230621101":"永乐镇","230621102":"丰乐镇","230621103":"朝阳沟镇","230621104":"兴城镇","230621105":"二井镇","230621202":"双发乡","230621203":"托古乡","230621205":"朝阳乡","230621206":"永胜乡","230621208":"榆树乡","230621211":"新福乡","230621580":"乐园良种场","230621581":"卫星种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230621.json
// module id = 679
// module chunks = 0